import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import timezones from "google-timezones-json";
// PAGE DEFAULTS
import Loader from "../../components/Loader";
import { resp } from "../../services/responseHandler";
import api from "../../api";
import AdminLayout from "../../components/adminLayout";
// PAGE DEFAULTS

// Google Calendar
// import {main} from './configuration.js'

// Google Calendar


export default class Engage extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search);
    const rec_biz_id = query.get("biz_id");
    const rec_bot_id = query.get("bot_id");
    this.state = {
      biz_id: rec_biz_id,
      bot_id: rec_bot_id,
      bot: {},
      biz: {},
      pref_appointment_service: "",
      google_calendar: {
        avg_time: "",
        time_zone: "",
        calendar_id: "",
        location: "",
      },
      calendly: {
        type: "appointment",
        url: "",
      },
      modalShow: false,
      loading: true,
      editMode: false,
      defaultTimeZones: timezones,
    };
    console.log("timezones", timezones);
  }

  componentDidMount() {
    this.getBot();
    this.getBusiness();
  }

  async getBot() {
    await api.getService(`/bot/${this.state.biz_id}/${this.state.bot_id}`).then(
      (res) => {
        console.log("Bot Resp:", res);
        let data = res?.data?.data;
        this.setState({
          bot: data,
        });
      },
      (error) => {
        console.log("error", error);
      }
    );
  }


  
  gcConfig = async (event) => {
    event.preventDefault();
  
  }

  async getBusiness() {
    api.getBusinessById(this.state.biz_id).then(
      (res) => {
        console.log("Response:", res);
        let biz_data = res?.data?.data;
        this.setState({
          biz: biz_data,
          pref_appointment_service: biz_data?.pref_appointment_service,
        });
        console.log("Business data", this.state.biz);
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
      }
    );
  }

  onChangeGC(e) {
    e.preventDefault();
    const { name, value } = e.target;
    this.state.google_calendar[name] = value;
  }

  handleServiceId = (event) => {
    const { name, value } = event.target;
    this.setState({ ...this.state, [name]: value });
  };

  handleChangeGc = (event) => {
    try {
      const { name, value } = event.target;
      this.setState({ ...this.state.google_calendar, [name]: value });
    } catch (error) {
      console.log(error);
    }
  };

  printState = () => {};
  showModal = () => {
    this.setState({ modalShow: true });
  };
  hideModal = () => {
    this.setState({ modalShow: false });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    var payload = {};
    if (this.state.pref_appointment_service === "google_calendar") {
      payload = {
        pref_appointment_service: this.state.pref_appointment_service,
        google_calendar: this.state.google_calendar,
      };
    } else if (this.state.pref_appointment_service === "calendly") {
      payload = {
        pref_appointment_service: this.state.pref_appointment_service,
        calendly: this.state.calendly,
      };
    }

    api.updateBusinessByID(this.state.biz._id, payload).then(
      (res) => {
        console.log("Response:", res);
        this.insertIntents();
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
        this.setState({ loading: false });
      }
    );
  };

  async insertIntents() {
    let query = {
      metric: "intents",
      bot_id: this.state.bot_id,
      service_id: this.state.pref_appointment_service,
    };
    api.postService(`/intents/${this.state.biz_id}`, query).then(
      (res) => {
        console.log("Response:", res);
        resp.ResponseHandler(res);
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
        this.setState({ loading: false });
      }
    );
  }

  openSetupBot = () => {
    this.setState({ editMode: false });
    this.showModal();
  };

  openUpdateBot = () => {
    this.setState({ editMode: true });
    if (this.state.pref_appointment_service === "google_calendar") {
      this.setState({ google_calendar: this.state.biz.google_calendar });
    } else if (this.state.pref_appointment_service === "calendly") {
      this.setState({ calendly: this.state.biz.calendly });
    }

    this.showModal();
  };

  handleInput = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleGoogleCalendar = (event) => {
    event.preventDefault();
    let prevState = this.state.google_calendar;
    prevState[event.target.name] = event.target.value;
    this.setState({ google_calendar: prevState });
  };

  handleCalendly = (event) => {
    event.preventDefault();
    let prevState = this.state.calendly;
    prevState[event.target.name] = event.target.value;
    this.setState({ calendly: prevState });
  };

  updateRecord = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    var payload = {};
    if (this.state.pref_appointment_service === "google_calendar") {
      payload = {
        google_calendar: this.state.google_calendar,
      };
    } else if (this.state.pref_appointment_service === "calendly") {
      payload = {
        calendly: this.state.calendly,
      };
    }

    this.updateBiz(payload);
  };

  updateBiz = async (payload) => {
    this.setState({ loading: true });
    await api.updateBusinessByID(this.state.biz._id, payload).then(
      (res) => {
        console.log("Response:", res);
        resp.ResponseHandler(res);
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
      }
    );
  };

  updateBotStatus = (status) => {
    this.setState({ loading: true });
    let query = { status: status };
    api
      .putService(
        `/activate_bot/${this.state.bot.biz_id}/${this.state.bot.id}`,
        query
      )
      .then(
        (res) => {
          console.log("Response:", res);
          resp.ResponseHandler(res);
          this.setState({ loading: false });
        },
        (error) => {
          console.log("error", error);
          resp.ErrorHandler(error);
          this.setState({ loading: false });
        }
      );
  };

  deleteBot = async () => {
    this.setState({ loading: true });
    let query = {};
    await api
      .deleteService(
        `/bot/${this.state.bot.biz_id}/${this.state.bot.id}`,
        query
      )
      .then(
        async (res) => {
          console.log("Response:", res);
          // this.setState({ loading: false });
          //resp.ResponseHandler(res, null);
          let payload = {
            google_calendar: {},
            Calendly: {},
            pref_appointment_service: "",
          };
          await this.updateBiz(payload);
          this.props.history.goBack();
        },
        (error) => {
          console.log("error", error);
          resp.ErrorHandler(error);
          this.setState({ loading: false });
        }
      );
  };


  render() {
    const {
      modalShow,
      biz,
      pref_appointment_service,
      google_calendar,
      calendly,
      editMode,
      defaultTimeZones,
    } = this.state;
    return (
      <AdminLayout>
        {this.state.loading ? <Loader /> : ""}
        <div className="row mb-5">
          <div className="col my-auto">
            <div className="buttons float-left">
              <button
                className="btn text-dark"
                onClick={this.props.history.goBack}
              >
                <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Go
                back
              </button>
            </div>
          </div>
          <div className="col my-auto text-center mx-auto clearfix">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png"
              className="img-fluid img-bot mr-3"
            />
            <span className="text-primary">
              <b>Appointment Bot</b>
            </span>
          </div>

          <div className="col my-auto text-center">

            <button
              type="button"
              class="btn btn-outline-danger"
              onClick={() => this.deleteBot()}
            >
              Delete Bot
            </button>
          </div>
        </div>

        {!biz?.pref_appointment_service && (
          <div class="row mx-auto my-auto">
            <div class="col-sm-12">
              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={() => this.openSetupBot()}
                >
                  <i class="fa fa-wrench" aria-hidden="true"></i>&nbsp;Setup
                </button>
              </div>
            </div>
          </div>
        )}

        {biz?.pref_appointment_service && biz?.pref_appointment_service != "" && (
          <div className="row w-100 mx-0">
            <div className="col-lg-8 mx-auto">
              <div className="card text-left py-5 px-4 px-sm-5">
                <div className=" buttons">
                  <button
                    type="button"
                    class="btn btn-link float-right"
                    onClick={() => this.openUpdateBot()}
                  >
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button>
                </div>
                <form>
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-muted">
                      Preferred service
                    </label>
                    <p class="col-form-label">
                      {biz?.pref_appointment_service}
                    </p>
                  </div>
                  {biz?.pref_appointment_service === "calendly" && (
                    <>
                      <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-muted">
                          URL
                        </label>
                        <p class="col-form-label">{biz?.calendly?.url}</p>
                      </div>
                    </>
                  )}
                  {biz?.pref_appointment_service === "google_calendar" && (
                    <>
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          Calendar Id
                        </label>
                        <p class="col-form-label">
                          {biz?.google_calendar?.calendar_id}
                        </p>
                      </div>

                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          Time Zone
                        </label>
                        <p class="col-form-label text-wrap text-truncate">
                          {biz?.google_calendar?.time_zone}
                        </p>
                      </div>

                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          Avg. Time
                        </label>
                        <p class="col-form-label text-wrap text-truncate">
                          {biz?.google_calendar?.avg_time} hrs
                        </p>
                      </div>

                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          Location
                        </label>
                        <p class="col-form-label text-wrap text-truncate">
                          {biz?.google_calendar?.location}
                        </p>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        <Modal show={modalShow} onHide={this.hideModal}>
          <Modal.Header closeButton>
            <Modal.Title>Bot setup</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={!editMode ? this.handleSubmit : this.updateRecord}>
              <div class="form-group">
                <label for="pref_service">Preferred service</label>
                <select
                  class="form-control"
                  name="pref_appointment_service"
                  id="pref_appointment_service"
                  value={pref_appointment_service}
                  onChange={this.handleInput}
                  disabled={editMode}
                  required
                >
                  <option value="" selected disabled></option>
                  <option value="google_calendar">Google calendar</option>
                  <option value="calendly">Calendly</option>
                </select>
              </div>
              {pref_appointment_service === "google_calendar" && (
                <>
                  <div class="form-group">
                    <label>Calendar Id</label>
                    <input
                      type="text"
                      name="calendar_id"
                      value={google_calendar.calendar_id}
                      className="form-control"
                      placeholder="(e.g: appointment@group.calendar.google.com)"
                      onChange={this.handleGoogleCalendar}
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label>Time Zone</label>

                    <select
                      class="form-control"
                      name="time_zone"
                      id="time_zone"
                      value={google_calendar.time_zone}
                      onChange={this.handleGoogleCalendar}
                      required
                    >
                      <option value="" selected disabled></option>

                      {Object.entries(defaultTimeZones).map((t, k) => (
                        <option key={k} value={t[0]}>
                          {t[1]}
                        </option>
                      ))}

                      {/* {defaultTimeZones.map((zone, index) => (
                        <option value={index}>{index}</option>
                      ))} */}
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Average meeting time</label>
                    <select
                      class="form-control"
                      name="avg_time"
                      id="avg_time"
                      value={google_calendar.avg_time}
                      onChange={this.handleGoogleCalendar}
                      required
                    >
                      <option value="" selected disabled></option>
                      <option value="0.25">15 mins</option>
                      <option value="0.5">30 mins</option>
                      <option value="1">1 Hour</option>
                      <option value="1.5">1.5 Hour</option>
                      <option value="2">2 Hour</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Location <small>(optional)</small></label>
                    <input
                      type="text"
                      name="location"
                      value={google_calendar.location}
                      className="form-control"
                      placeholder="(e.g: SSD Clinic, 23 West cross street,LA)"
                      onChange={this.handleGoogleCalendar}
                      
                    />
                  </div>
                  <div class="form-group">
                    <p><b>Note:</b> Add this service account to your calendar.
                    <br/><b>dialogflow@quickdesk-4cfad.iam.gserviceaccount.com</b>
                    <br/>
                    <small>Your Calendar -> Settings -> Add people (with "Make changes to events" permission.)</small>
                    </p>
              
                  </div>
                </>
              )}

              {pref_appointment_service === "calendly" && (
                <div class="form-group">
                  <label>Calendly URL</label>
                  <input
                    type="text"
                    name="url"
                    value={calendly.url}
                    className="form-control"
                    placeholder=""
                    onChange={this.handleCalendly}
                    required
                  />
                </div>
              )}
              <div className="float-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-3"
                  onClick={this.hideModal}
                >
                  Close
                </button>
                {editMode ? (
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                ) : (
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                )}
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </AdminLayout>
    );
  }
}
